import React, { useState, useContext, useEffect } from 'react'
import { Form, Switch, Divider } from 'antd'
import { CreateMemberLyfeContext } from '../../../../../../..'
// import TooltipInfo from '../../../../../../../../CreateEventV2/TooltipInfo'
import HourForm from '../HourForm'
import './index.styl'

const { Item, List } = Form

const Friday = ({ currentPageDetails }) => {
  const { form } = useContext(CreateMemberLyfeContext)

  const [fridaySwitch, setFridaySwitch] = useState(false)
  const [hours, setHours] = useState(form.getFieldValue('friday') || [])
  // const mobile = window.innerWidth <= 730
  // const tooltipTitle = `Charity Raffles are limited to $30,000 in total ticket sales and $100 max price per ticket

  // Ticket Lyfe charges for Charity Raffle Tickets are $1 for Raffles priced up to $50 and $2 for higher priced Raffle Tickets

  // Do not pick Charity Raffles if you are doing a regular event with Random Draw Prizes--Because you can do a Random Draw on ANY Ticket Lyfe Event, the Charity Raffle limits above will not apply, and Ticket Lyfe treat your event as an ordinary Ticketed Event`

  // const additionalTooltip = (
  //  <TooltipInfo
  //    className='tooltipTitle'
  //    text={mobile ? '' : 'Additional info'}
  //    info={tooltipTitle}
  //  />
  // )

  useEffect(() => {
    if (currentPageDetails?.workingHours?.friday?.length) {
      setFridaySwitch(true)
      setHours(currentPageDetails.workingHours.friday)
    }
  }, [currentPageDetails])

  useEffect(() => {
    if (!hours.length) {
      setFridaySwitch(false)
      form.setFieldsValue({
        fridaySwitch: false,
      })
    }
  }, [hours, form])

  const handleSwitchChange = checked => {
    setFridaySwitch(checked)
    if (checked && !hours.length) {
      const newHour = [{}]
      setHours(newHour)
      form.setFieldsValue({
        friday: newHour,
      })
    }
  }

  const getFridayData = idx => {
    return hours[idx]
  }

  return (
    <div className='mondayWrapper'>
      <div className={fridaySwitch ? 'betweenWraper active' : 'betweenWraper'}>
        <div className='radioWrapper'>
          <Item style={{ marginBottom: 0 }} name='fridaySwitch' valuePropName='checked' className='monday'>
            <Switch onChange={handleSwitchChange} />
          </Item>
          <div className='text'>Friday</div>
        </div>
        {/* <div className='tooltipWrapper'>{additionalTooltip}</div> */}
      </div>
      {fridaySwitch && (
        <List name='friday'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <HourForm
                  fieldName='friday'
                  categoryData={getFridayData(fieldKey)}
                  form={form}
                  key={key}
                  name={name}
                  fieldKey={fieldKey}
                  onRemove={index => {
                    remove(index)
                    const updatedHours = form.getFieldValue('friday')
                    setHours(updatedHours)
                    if (updatedHours.length === 0) {
                      form.setFieldsValue({
                        fridaySwitch: false,
                      })
                    }
                  }}
                  {...restField}
                />
              ))}
              <div
                id='addCategory' className='addCategoryBtn' onClick={() => {
                  add()
                  const updatedHours = form.getFieldValue('friday')
                  setHours(updatedHours)
                }}
              >Add Another Activity
              </div>
            </>
          )}
        </List>
      )}
      <Divider />
    </div>
  )
}

export default Friday
